import { PillarPage } from 'src/constants/searchPages'

/**
 * English display nouns for each pillar.
 *
 * These deliberately live OUTSIDE `searchPages.tsx`. That file is one of the
 * five cross-repo mirrors kept in sync with `spotme-server` (root CLAUDE.md →
 * "Cross-repo mirrors that MUST stay in sync"), so we keep its diff surface at
 * zero. The server has no `searchName` / `label` concept at all — they are
 * client-only display copy — which is exactly why the English variants belong
 * in their own module rather than as extra fields on the mirrored map.
 *
 * Why this exists: `searchName` is interpolated into otherwise-translated
 * strings. Before this, the `/en` listing page rendered headings like
 * "Mini bodegas en renta near Buenos Aires" — an English template with a
 * Spanish noun substituted into it. Same for every `{{searchName}}` slot in
 * the SEO footer.
 *
 * Keep the four pillar entries in step with `PILLAR_PAGE_MAP` whenever a
 * pillar is added, renamed, or removed.
 */
type PillarNamesEn = {
  /** Mirrors `searchName` — the noun used inside sentences. */
  searchName: string
  /** Mirrors `searchNameH1` — H1 variant, falls back to `searchName`. */
  searchNameH1?: string
  /** Mirrors `label` — the short nav/breadcrumb form. */
  label: string
}

export const PILLAR_NAMES_EN: Record<PillarPage, PillarNamesEn> = {
  [PillarPage.SelfStorage]: {
    searchName: 'Self-storage units for rent',
    label: 'Self Storage'
  },
  [PillarPage.Parking]: {
    searchName: 'Monthly parking',
    searchNameH1: 'Parking for rent',
    label: 'Parking'
  },
  [PillarPage.Warehouse]: {
    searchName: 'Commercial warehouses for rent',
    label: 'Commercial Warehouses'
  },
  [PillarPage.Industrial]: {
    searchName: 'Industrial warehouses for rent',
    label: 'Industrial Warehouses'
  }
}
